import { QRCallToActionWeb, EFlyerFooterWeb } from '../../common';
import React from 'react';

import { PtgFeaturesContextType } from './PtgFeaturesContextType';
import { HTMLWidget } from 'app/common/components';

export const PtgFeaturesWeb = ({ context }) => (
  <div>
    <div id="header-container">
      <div
        id={'header'}
        className={
          'md:w-letter w-full px-4 mx-auto flex flex-1 justify-between h-32 border-b-8 border-primary-600'
        }
      >
        <div className="h-18 my-auto">
          <img
            src={context.logoUrl}
            alt={context.title}
            className="h-full object-contain mx-auto ml-1"
          />
        </div>
        <div className="text-primary-500 text-lg md:text-2xl mt-4 md:mt-8 ml-5 text-right">
          <div className="whitespace-nowrap">{context.heading1}</div>
          <div className="font-bold whitespace-nowrap">{context.heading2}</div>
        </div>
      </div>
    </div>
    <div id="main-container">
      <div
        id={'main'}
        className={'md:w-letter w-full px-4 mx-auto text-gray-800'}
      >
        <div className="my-6">
          <h2 className="text-3xl md:text-5xl font-bold text-primary-600 mb-2">
            {context.title}
          </h2>
        </div>
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-1/2">
            <img
              src={context.mainImageUrl}
              alt={context.title}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-full md:w-1/2 p-4 md:p-6">
            <HTMLWidget
              content={context.paragraph}
              className={'md:pl-4 text-xl md:text-2xl'}
            />
          </div>
        </div>
        <div className="my-8">
          <h3 className={'font-bold mb-2 text-xl'}>
            {context.featuresHeading}
          </h3>
          <ul className="list-disc ml-4 text-xl">
            {context.features &&
              context.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
          </ul>
        </div>
        <div className={'mt-12'}>
          <QRCallToActionWeb
            callToAction={context.callToAction}
            qrUrl={context.qrUrl}
            qrImage={context.qrImage}
          />
        </div>
      </div>
    </div>
    <div id="footer-container" className={'bg-primary-600 mt-6'}>
      <div id={'footer'} className={'md:w-letter w-full px-4 ml-auto mr-auto'}>
        <EFlyerFooterWeb footer={context.footer} />
      </div>
    </div>
  </div>
);

PtgFeaturesWeb.propTypes = {
  context: PtgFeaturesContextType.isRequired
};
